{
  "commonHeader": {
    "toggleSidebar": "Toggle sidebar",
    "cartLoading": "Shopping cart loading",
    "cart": "Shopping cart",
    "aicForAdmin": {
      "ariaLabel": "AI for admin"
    },
    "usersResults": "Users, {0} results",
    "settingsResults": "Settings, {0} results",
    "navigationResults": "Navigation, {0} results",
    "learnMoreAbout": "Learn more about {0}",
    "close": "Close",
    "products": "Products",
    "moreActions": "More actions",
    "search": "Search",
    "searchPlaceholderAll": "Search for users, account settings, or navigation",
    "searchPlaceholderUsers": "Search for users, or navigation",
    "searchPlaceholderSettings": "Search for account settings, or navigation",
    "searchPlaceholderNav": "Search for navigation"
  },
  "footerCopyright": {
    "language": "Language {0}"
  },
  "adminMenu": {
    "adminMenu": {
      "ariaLabel": "Admin menu"
    }
  },
  "shared": {
    "close": "Close",
    "sideMenu": {
      "personalAria": "Personal menu",
      "adminAria": "Admin menu",
      "mainNav": "Main navigation",
      "submenu": "Submenu",
      "pinnedSection": "{0} pinned",
      "sideMenuAria": "Side menu",
      "pinItem": "Pin {0}",
      "unpinItem": "Unpin {0}",
      "reorderGrabbed": "Reorder {0}, grabbed. Use up and down arrow keys to move, press space or enter to drop, press escape to cancel.",
      "reorderIdle": "Reorder {0}. Press space or enter to grab.",
      "hintHandlePin": "Press Tab to access drag handle and pin button",
      "hintHandle": "Press Tab to access drag handle",
      "hintPin": "Press Tab to access pin button",
      "upgradeToPro": "Upgrade to Pro"
    },
    "item": "Item"
  },
  "coachMark": {
    "coachMark": {
      "tryNewExperienceAria": "Try new experience"
    }
  },
  "aicGuide": {
    "common": {
      "close": "Close"
    }
  },
  "divisionTips": {
    "coachMark": {
      "dvsTipsTitle": "Divisions are now available"
    }
  },
  "externalAccountTips": {
    "coachMark": {
      "extAccountTipsTitle": "Manage external accounts"
    }
  },
  "zccRenameTips": {
    "coachMark": {
      "tipsTitle": "Address Book will become Customer Directory"
    }
  },
  "feedback": {
    "itemLableForProductArea": "Product Area",
    "itemLableForFeedback": "Feedback"
  }
}
